import React from 'react';
import { Divider as TPADivider } from '@wix/wix-ui-tpa/cssVars';

import { classes } from './divider.st.css';

export const Divider = () => <TPADivider className={classes.root} />;
